import { Component, OnInit } from '@angular/core';


@Component({
    templateUrl: '../Templates/home.component.html',
    //styleUrls: ['../Styles/home.component.css']
})

export class HomeComponent implements OnInit {


  ngOnInit() {
    // scroll window to top. Schijnt in toekomstge angular versie misschien niet meer nodig te zijn?
    window.scrollTo(0, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/Components/home.ts